import BaseApi from '@/api/controller/base';

const EB_OPTOUT_API_URL = 'earlyBirdOptout/';

class EBOptoutApi extends BaseApi {
  constructor() {
    super(EB_OPTOUT_API_URL);
  }

  remove(clientId) {
    return this.api.post(`remove/${clientId}`);
  }

  optout(clientId) {
    return this.api.post(`optout/${clientId}`);
  }
}

const apiInstance = new EBOptoutApi();
export { EBOptoutApi, apiInstance };
export default apiInstance;
